
import { defineComponent } from "vue";
import Quiz from "@/pages/Quiz.vue";

export default defineComponent({
  name: "App",
  components: {
    Quiz,
  },
});
